import type { I18nKey } from 'common/hooks/useTranslation';

export type AvailableAuthenticationMethods = 'TOTP' | 'MOBILE_APP' | 'SMS';

export const availableAuthenticationMethodTranslations: Record<
  Lowercase<AvailableAuthenticationMethods>,
  {
    label: I18nKey;
    description: I18nKey;
    iconName: 'lock-close' | 'smartphone' | 'chat-bubble-ellipsis';
  }
> = {
  totp: {
    label: 'profile.authenticationFactors.create.step1TotpChoiceTitle',
    description:
      'profile.authenticationFactors.create.step1TotpChoiceDescription',
    iconName: 'lock-close',
  },
  // eslint-disable-next-line camelcase
  mobile_app: {
    label: 'profile.authenticationFactors.create.step1MobileChoiceTitle',
    description:
      'profile.authenticationFactors.create.step1MobileChoiceDescription',
    iconName: 'smartphone',
  },
  sms: {
    label: 'profile.authenticationFactors.create.step1SmsChoiceTitle',
    description:
      'profile.authenticationFactors.create.step1SmsChoiceDescription',
    iconName: 'chat-bubble-ellipsis',
  },
};
